import React, { useState } from "react";
import Dialog from "../../dialog/ImgDialog";
import "../../dialog/imgStyle.css";

function FeedBackDialog({ selectedRowData, handleDialogClose }) {
  const [open, setOpen] = useState([true]);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <div>
        <Dialog
          visible={selectedRowData}
          //   title={"Enter your amount"}
          // open={open}
          handleClose={handleDialogClose}
          // actionsPannel={DialogActions("bg-green")}
          size={"w-2/7"}
          color={"bg-green"}
        >
          <div
            className="w-[900px] scrollbar-hide"
            style={{ maxHeight: "90vh" }}
          >
            <div className="">
              <div>
                <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
                  <div style={{
                    minHeight: "400px",
                    maxHeight: "400px",
                    overflowY: "scroll",
                    overflowX: "hidden",
                  }}>
                    <table
                      className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                      <caption className="p-5 text-lg font-semibold text-left rtl:text-right text-gray-900 bg-white dark:text-white dark:bg-gray-800">
                        Feedback
                      </caption>
                      <thead className="text-sm text-black  bg-[#DBE6FF] ">
                        <tr>
                          <th scope="col" className=" py-3 ">
                            <div className=" px-6 border-r-2 border-[#868686] ">
                              Round
                            </div>
                          </th>
                          <th
                            scope="col"
                            className=" py-3 text-center w-[240px] "
                          >
                            <div className=" px-6 border-r-2 border-[#868686] ">
                              Date & Time
                            </div>
                          </th>
                          <th scope="col" className=" py-3 w-[130px] ">
                            <div className="px-6 border-r-2 border-[#868686] text-center ">
                              Given By
                            </div>
                          </th>
                          <th scope="col" className="px-6 py-3 text-center ">
                            Feedback
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {selectedRowData?.map(item =>(<tr className="bg-white border-b ">
                        <th
                          scope="row"
                          className="px-6 py-4 font-medium text-black whitespace-nowrap "
                        >
                          {item?.status_name}
                        </th>
                        <td className="px-6 py-4 text-black text-center ">
                        {item?.timestamp}
                        </td>
                        <td className="px-6 py-4 text-black text-center ">
                        {item?.user_name}
                        </td>
                        <td className="px-6 py-4 text-black">
                        {item?.feedback}
                        </td>
                      </tr>))}
                       
                      </tbody>
                    </table>
                  </div>
                  <div className="flex justify-end pr-4 pb-4 mt-4">
                    {/* <button
                      type="button"
                      className="border border-[#6C757D] text-[#6C757D] text-sm  h-[45px] w-[150px] rounded-md mr-3 "
                    >
                      Cancel
                    </button> */}
                    <button
                      onClick={handleDialogClose}
                      type="button"
                      className="bg-[#2563EB] text-white text-sm  h-[45px] w-[150px] rounded-md "
                    >
                      Done
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Dialog>
      </div>
    </div>
  );
}

export default FeedBackDialog;
